import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f7e1a3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  align: "start",
  justify: "space-between",
  class: "flex mb-10"
}
const _hoisted_2 = { class: "flex-item" }
const _hoisted_3 = { class: "flex-item" }
const _hoisted_4 = { class: "flex-item" }
const _hoisted_5 = { class: "flex-item" }

import { useI18n } from "vue-i18n"
import { ref, onMounted, computed, Ref } from "vue"
import { Applicant, DashboardData, RequestResponse } from "@/types"
import ApplicationsTable from "@/components/Doctors/Dashboard/DoctorOverview/ApplicationsTable/ApplicationsTable.vue"
import { watch } from "vue"
import { hospitalActions } from "@/stores/hospital-actions"

export default /*#__PURE__*/_defineComponent({
  __name: 'BriefOverview',
  props: {
    data: {}
  },
  setup(__props: any) {

const { t } = useI18n()

const hospitalAction = hospitalActions()
const props = __props
const dashboardData = ref<DashboardData | undefined>(props.data)
const tab = ref<string>(
  hospitalAction.studentTableTab !== "" ? hospitalAction.studentTableTab : ""
)
const requestResponse = ref()
const loading = ref(false)

watch([tab], () => {
  hospitalAction.studentTableTab = tab.value
})

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_request_status, {
      response: requestResponse.value,
      isLoading: loading.value
    }, null, 8, ["response", "isLoading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_card, {
          class: "mx-auto mt-2",
          height: "200",
          width: "200",
          style: {"border-radius":"10%"},
          title: _ctx.$t('applications.open'),
          align: "center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'CREATED'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: require('../../../../assets/student5.png'),
              width: "100",
              height: "100"
            }, null, 8, ["src"]),
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(dashboardData.value?.applicants.CREATED ?? 0), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_card, {
          class: "mx-auto mt-2",
          height: "200",
          width: "200",
          style: {"border-radius":"10%"},
          title: _ctx.$t('applications.accepted'),
          align: "center",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'ACCEPTED'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: require('../../../../assets/student6.png'),
              width: "100",
              height: "100"
            }, null, 8, ["src"]),
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(dashboardData.value?.applicants.ACCEPTED ?? 0), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_card, {
          class: "mx-auto mt-2",
          height: "200",
          width: "200",
          style: {"border-radius":"10%"},
          title: _ctx.$t('applications.rejected'),
          align: "center",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 'REJECTED'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: require('../../../../assets/student7.png'),
              width: "100",
              height: "100"
            }, null, 8, ["src"]),
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(dashboardData.value?.applicants.REJECTED ?? 0), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_card, {
          class: "mx-auto mt-2",
          height: "200",
          width: "200",
          style: {"border-radius":"10%"},
          title: _ctx.$t('applications.all'),
          align: "center",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (tab.value = ''))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: require('../../../../assets/student8.png'),
              width: "100",
              height: "100"
            }, null, 8, ["src"]),
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString((dashboardData.value?.applicants.ACCEPTED ?? 0) +
            (dashboardData.value?.applicants.REJECTED ?? 0) +
            (dashboardData.value?.applicants.CREATED ?? 0)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"])
      ])
    ]),
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tab).value = $event)),
          "show-arrows": "",
          "bg-color": "#25344d",
          "fixed-tabs": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, { value: "CREATED" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("applications.open")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, { value: "ACCEPTED" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("applications.accepted")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, { value: "REJECTED" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("applications.rejected")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, { value: "" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("applications.all")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_window, {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tab).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "CREATED" }, {
                  default: _withCtx(() => [
                    _createVNode(ApplicationsTable, {
                      isHospital: true,
                      tab: 'CREATED'
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "ACCEPTED" }, {
                  default: _withCtx(() => [
                    _createVNode(ApplicationsTable, {
                      isHospital: true,
                      tab: 'ACCEPTED'
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "REJECTED" }, {
                  default: _withCtx(() => [
                    _createVNode(ApplicationsTable, {
                      isHospital: true,
                      tab: 'REJECTED'
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "" }, {
                  default: _withCtx(() => [
                    _createVNode(ApplicationsTable, {
                      isHospital: true,
                      tab: tab.value
                    }, null, 8, ["tab"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})